function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_13769_15540)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M20.64 3.35844H17.76V2.39844H6.24002V3.35844H3.36002C2.78402 3.35844 2.40002 3.74244 2.40002 4.31844V6.62244C2.40002 8.83044 4.03202 10.6544 6.24002 10.9424V11.0384C6.24002 13.8224 8.16002 16.1264 10.752 16.7024L10.08 18.7184H7.87202C7.48802 18.7184 7.10402 19.0064 7.00802 19.3904L6.24002 21.5984H17.76L16.992 19.3904C16.896 19.0064 16.512 18.7184 16.128 18.7184H13.92L13.248 16.7024C15.84 16.1264 17.76 13.8224 17.76 11.0384V10.9424C19.968 10.6544 21.6 8.83044 21.6 6.62244V4.31844C21.6 3.74244 21.216 3.35844 20.64 3.35844ZM6.24002 9.02244C5.18402 8.73444 4.32002 7.77444 4.32002 6.62244V5.27844H6.24002V9.02244ZM13.92 11.9984L12 10.9424L10.08 11.9984L10.56 10.0784L9.12002 8.15844H11.136L12 6.23844L12.864 8.15844H14.88L13.44 10.0784L13.92 11.9984ZM19.68 6.62244C19.68 7.77444 18.816 8.83044 17.76 9.02244V5.27844H19.68V6.62244Z",
  fill: "white"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_13769_15540"
}, /*#__PURE__*/React.createElement("rect", {
  width: 19.2,
  height: 19.2,
  fill: "white",
  transform: "translate(2.40002 2.39844)"
})));

var SvgWinner = function SvgWinner(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgWinner, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/winner.5637ad12.svg";
export { ForwardRef as ReactComponent };